export default "__VITE_ASSET__7edc3a24__"